import { Action } from "../../index";
import { combineReducers } from "redux";
import API from "../../../vendor/api";
API.transportMethod = "WS";

import { normalize, Schema, arrayOf } from "normalizr";

import { IMessagesNormalizedById } from "../../../types/index";

const chat = new Schema("chats");
const message = new Schema("messages");


chat.define({
  messages: arrayOf(message)
});

/**
 * Actions
 */
// Add message
export const SET_MESSAGE_ENTITIES = "meumedico/chats/SET_MESSAGE_ENTITIES";
export function setMessageEntities(messages: messagesById) {
    return {
        type: SET_MESSAGE_ENTITIES,
        payload: {
            messages
        }
    }
}

export enum addMessageEntitiesPosition {
    Prepend,
    Append
}

export const ADD_MESSAGE_ENTITIES = "meumedico/chats/ADD_MESSAGE_ENTITIES";
export function addMessageEntities(messages: messagesById, position: addMessageEntitiesPosition, chatId: string) {
    return {
        type: ADD_MESSAGE_ENTITIES,
        payload: {
            messages,
            position,
            chatId
        }
    }
}

export const ADD_MESSAGE_ENTITY= "meumedico/chats/ADD_MESSAGE_ENTITY";
export function addMessageEntity(message: API.Message, currentUserId: string, currentChatId: string) {
    return {
        type: ADD_MESSAGE_ENTITY,
        payload: {
            message,
            currentUserId, 
            currentChatId
        }
    }
}

// Reducer
interface messagesById {
    [chatId: string]: API.Message;
}

export interface MessageState {
    allIds: string[];
    byId: messagesById;
}

const INITIAL_STATE: MessageState = {
    allIds: [],
    byId: {}
}

export interface MessageEntityPayload {
    message: API.Message;
    currentUserId: string;
    currentChatId: string;
}

export interface MessageEntitiesPayload {
    messages: messagesById;
    position?: addMessageEntitiesPosition;
    chatId?: string;
}

function messagesById(state: any = {}, action: Action<MessageEntityPayload & MessageEntitiesPayload>) {
    switch(action.type) {
        case SET_MESSAGE_ENTITIES:
            return Object.assign({}, action.payload.messages);
        case ADD_MESSAGE_ENTITIES:
            return (() => {
                let newMessages: IMessagesNormalizedById = {};
                const messages = action.payload.messages;

                if (!messages) {
                    return state;
                }

                Object.keys(messages).map(messageId => {
                    newMessages[messageId] = messages[messageId];
                });
                return Object.assign({}, state, newMessages);
            })();
            
        case ADD_MESSAGE_ENTITY:
            let messages = Object.assign({}, state);
            messages[action.payload.message.id] = action.payload.message;
            return messages;
        default:
            return state;
    }
}

function allMessages(state: any = [], action: Action<any>) {
    switch(action.type) {
        case SET_MESSAGE_ENTITIES:
            return Object.keys(action.payload.messages);
        case ADD_MESSAGE_ENTITIES:
            return state.concat(Object.keys(action.payload.messages));
        case ADD_MESSAGE_ENTITY:
            return state.concat([action.payload.message.id]);
        default:
            return state;
    }
}

const chatsReducer = combineReducers({
    byId : messagesById,
    allIds : allMessages
});

export default chatsReducer;


// WEBPACK FOOTER //
// ./src/redux/modules/messages/messages.tsx